"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanize = exports.shorten = void 0;
var translate_1 = require("./translate");
var abbreviations = {
    none: function (n, locale) { return n.toLocaleString(locale); },
    thousands: function (n, locale) {
        return translate_1.translate({
            singular: '{COUNT}K',
            replacements: {
                COUNT: n.toLocaleString(locale),
            },
            dictionary: {
                'de-DE': {
                    singular: '{COUNT}K',
                },
                en: {
                    singular: '{COUNT}K',
                },
                es: {
                    singular: '{COUNT} k',
                },
                'fr-FR': {
                    singular: '{COUNT}K',
                },
                'ja-JP': {
                    singular: '{COUNT}千',
                },
                'ko-KR': {
                    singular: '{COUNT}천',
                },
                'pt-BR': {
                    singular: '{COUNT}Mil',
                },
            },
        });
    },
    millions: function (n, locale) {
        return translate_1.translate({
            singular: '{COUNT}M',
            replacements: {
                COUNT: n.toLocaleString(locale),
            },
            dictionary: {
                'de-DE': {
                    singular: '{COUNT}M',
                },
                en: {
                    singular: '{COUNT}M',
                },
                es: {
                    singular: '{COUNT} M',
                },
                'fr-FR': {
                    singular: '{COUNT}M',
                },
                'ja-JP': {
                    singular: '{COUNT}万',
                },
                'ko-KR': {
                    singular: '{COUNT}만',
                },
                'pt-BR': {
                    singular: '{COUNT}M',
                },
            },
        });
    },
    billions: function (n, locale) {
        return translate_1.translate({
            singular: '{COUNT}B',
            replacements: {
                COUNT: n.toLocaleString(locale),
            },
            dictionary: {
                'de-DE': {
                    singular: '{COUNT}B',
                },
                en: {
                    singular: '{COUNT}B',
                },
                es: {
                    singular: '{COUNT} G',
                },
                'fr-FR': {
                    singular: '{COUNT}B',
                },
                'ja-JP': {
                    singular: '{COUNT}億',
                },
                'ko-KR': {
                    singular: '{COUNT}억',
                },
                'pt-BR': {
                    singular: '{COUNT}B',
                },
            },
        });
    },
    infinity: function () { return '∞'; },
};
/**
 * Shortens numbers down to maximum number of digits and decimals.
 *
 * For example:
 * shorten(1294, 3, 0) => 1
 * shorten(1294, 3, 1) => 1.2
 * shorten(9999999, 6, 0) => 9
 * shorten(9999999, 6, 1) => 9.9
 * shorten(9999999, 6, 2) => 9.99
 *
 * Numbers always round down.
 */
var shorten = function (n, magnitude, sigDigits) {
    if (sigDigits === void 0) { sigDigits = 0; }
    var factor = Math.pow(10, magnitude - sigDigits);
    return Math.floor(n / factor) / Math.pow(10, sigDigits);
};
exports.shorten = shorten;
/**
 * This is ideally the single source of truth for displaying correctly
 * formatted and localized numbers on the frontend. It *mostly* mirrors
 * our PHP formatBigNumbers method.
 *
 * These are the rules:
 * 0 - 9,999
 * 10K - 99.9K
 * 100K - 999K
 * 1M - 99.9M
 * 100M - 999M
 * 1B - 99.9B
 * 100B - 999B
 * ∞
 *
 * All numbers round DOWN
 */
var humanize = function (n) {
    var locale = translate_1.getCurrentLocale();
    switch (true) {
        // 0 - 9,999
        case n < 10000:
            return abbreviations.none(n, locale);
        // 10K - 99.9K
        case n < 100000:
            return abbreviations.thousands(exports.shorten(n, 3, 1), locale);
        // 100K - 999K
        case n < 1000000:
            return abbreviations.thousands(exports.shorten(n, 3, 0), locale);
        // 1M - 99.9M
        case n < 100000000:
            return abbreviations.millions(exports.shorten(n, 6, 1), locale);
        // 100M - 999M
        case n < 1000000000:
            return abbreviations.millions(exports.shorten(n, 6, 0), locale);
        // 1B - 99.9B lol
        case n < 100000000000:
            return abbreviations.billions(exports.shorten(n, 9, 1), locale);
        // 100B - 999B o.O
        case n < 1000000000000:
            return abbreviations.billions(exports.shorten(n, 9, 0), locale);
        // ¯\_(ツ)_/¯
        default:
            return abbreviations.infinity();
    }
};
exports.humanize = humanize;
//# sourceMappingURL=humanize.js.map